import { render, staticRenderFns } from "./wrathOfEgypt.vue?vue&type=template&id=2a225bc0"
import script from "./wrathOfEgypt.vue?vue&type=script&lang=js"
export * from "./wrathOfEgypt.vue?vue&type=script&lang=js"
import style0 from "./wrathOfEgypt.vue?vue&type=style&index=0&id=2a225bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports